export default {
    methods: {
        getUniqueKey () {
            return Math.ceil(Math.random() * 1000000000000);
        }
    }
};
